module.exports = __webpack_public_path__ + "img/sea-urchin.135ae9ef.png";